import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Col } from "../../../components/ui";

import SidebarMainNavbar from "./SidebarMainNavbar";
import SidebarSearch from "./SidebarSearch";
import SidebarNavItems from "./SidebarNavItems";
import Ticker from "../MainNavbar/NavbarNav/Ticker";
import publisherStore from "../../../flux/publisherStore";
import { getPublishers } from "../../../flux/publisherAction";
import { withRouter } from "../../../hooks/withRouter";

import { Store } from "../../../flux";
import Constants from "../../../flux/constants";
import Dispatcher from "../../../flux/dispatcher";

class MainSidebar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menuVisible: false,
      sidebarNavItems: Store.getSidebarItems(),
    };

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    Store.addChangeListener(this.onChange);
    this.fetchPublishers();
  }

  componentWillUnmount() {
    Store.removeChangeListener(this.onChange);
  }

  componentDidUpdate(prevProps) {
    // Close sidebar when route changes (mobile navigation fix)
    if (this.props.location?.pathname !== prevProps.location?.pathname) {
      if (this.state.menuVisible && window.screen.width < 767) {
        // Toggle sidebar to close it
        Dispatcher.dispatch({
          actionType: Constants.TOGGLE_SIDEBAR
        });
      }
    }
  }

  fetchPublishers = () => {
    if (publisherStore.getPublishers().length === 0) getPublishers();
  };

  onChange() {
    this.setState({
      ...this.state,
      menuVisible: Store.getMenuState(),
      sidebarNavItems: Store.getSidebarItems(),
    });
  }

  render() {
    const classes = classNames(
      "main-sidebar",
      "px-0",
      "col-12",
      this.state.menuVisible && "open"
    );

    return (
      window.screen.width < 767 && (
        <Col tag="aside" className={classes} lg={{ size: 2 }} md={{ size: 3 }}>
          <React.Fragment>
            <SidebarMainNavbar hideLogoText={this.props.hideLogoText} />
            {/* <div style={{ border: "1px solid #e1e5eb" }}>
              <Ticker />
            </div> */}
            {/* <SidebarSearch /> */}
            <SidebarNavItems />
          </React.Fragment>
        </Col>
      )
    );
  }
}

MainSidebar.propTypes = {
  /**
   * Whether to hide the logo text, or not.
   */
  hideLogoText: PropTypes.bool,
};

MainSidebar.defaultProps = {
  hideLogoText: false,
};

export default withRouter(MainSidebar);
